import { Injectable } from '@angular/core';
import { FormatNumberPipe } from '../pipes/src/lib/phone.pipe';

@Injectable()
export class PhoneFormatService {
  public constructor(private phonePipe: FormatNumberPipe) {}

  public toPhoneFormat(value: number): string {
    value = typeof value === 'undefined' ? 0 : value;

    const formattedValues = this.phonePipe.transform(value);
    return formattedValues;
  }
}
